exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-group, .btn-group-vertical {\n    width: 100%;\n}\n\n.btn-square {\n    font-size: 1.5em;\n    height: 33vw;\n    margin-top: 1em;\n}\n\n.col-form-label {\n    text-align: right;\n}\n\n.input-group>.input-group-append>.input-group-text {\n    min-width: 3em;\n}\n\n.input-group>.input-group-prepend>.input-group-text {\n    min-width: 6em;\n}\n", ""]);

// exports
